import { makeStyles } from '@material-ui/core/styles';

import { cardRadius, cardShadow, colors, typography } from '../../tokens';

const useStyles = makeStyles(theme => ({
  topCard: {
    height: '100%',
    minHeight: 168,
    padding: theme.spacing(3),
    borderRadius: cardRadius,
    boxShadow: cardShadow,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      minHeight: 142,
      padding: theme.spacing(2),
    },
  },
  metricLine: {
    display: 'flex',
    alignItems: 'center',
  },
  roundIcon: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    color: '#fff',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: 28,
      height: 28,
      marginRight: theme.spacing(1.5),
    },
  },
  metricValue: {
    fontSize: typography.metricValue.fontSize,
    lineHeight: 1,
    color: colors.textPrimary,
    fontWeight: typography.metricValue.fontWeight,
    letterSpacing: typography.metricValue.letterSpacing,
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
    },
  },
  metricDescription: {
    fontSize: typography.body.fontSize,
    lineHeight: typography.body.lineHeight,
    letterSpacing: typography.body.letterSpacing,
    color: colors.textSecondary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  goal: {
    fontSize: typography.overline.fontSize,
    fontWeight: typography.overline.fontWeight,
    letterSpacing: typography.overline.letterSpacing,
    textTransform: 'uppercase',
    color: colors.textSecondary,
    marginTop: 'auto',
  },
}));

export default useStyles;
